import { useParams } from "react-router-dom";
import TheReflexChallenge from "../../activities/TheReflexChallenge/TheReflexChallenge";
import VisionTT from "../../activities/VisionTT/VisionTT";
import RapidClicker from "../../activities/RapidClicker/RapidClicker";
import TravelPassport from "../../activities/TravelPassport/TravelPassport";
import WikiSpeedrun from "../../activities/WikiSpeedrun/WikiSpeedrun";
import ColorMatch from "../../activities/ColorMatch/ColorMatch";
import QuizTT from "../../activities/QuizTT/QuizTT";
import GuessCountryGame from "../../activities/GuessCountryGame/GuessCountryGame";
import MathBlitz from "../../activities/MathBlitz/MathBlitz";
import CatchTheBalls from "../../activities/CatchTheBalls/CatchTheBalls";
import MemoryTest from "../../activities/MemoryTest/MemoryTest";
import "./ActivityScreen.css";

const activities = {
  TheReflexChallenge,
  VisionTT,
  RapidClicker,
  TravelPassport,
  WikiSpeedrun,
  ColorMatch,
  QuizTT,
  GuessCountryGame,
  MathBlitz,
  CatchTheBalls,
  MemoryTest,
};

export default function ActivityScreen() {
  const { name } = useParams();

  const Activity = activities[name] || (() => <div>Activity not found</div>);

  return (
    <div className="activityScreen-main">
      <Activity />
    </div>
  );
}
